<template>
  <v-btn
    color="primary"
    rounded
    dark
    outlined
    href="https://forms.gle/BVhK9WWjYSNwDU3p8"
    target="_blank"
  >Sign up now</v-btn>
</template>

<script>
  export default {
    name: 'SignUpButton',
    props: {
    },
    data: () => ({
    }),
  }
</script>
